import { Component } from '@angular/core';
import {
    LocalStorageService, TokenService, PlatformService,
    LoggingService, NotificationsService, User, Confirmation, AccountService, SettingsService
} from '@varsity/services';

import { StatusBar } from '@ionic-native/status-bar';
import { App, PopoverController } from 'ionic-angular';
import { DisplayMessageComponent } from '@varsity/components';
import { Observable, Subscription } from 'rxjs';
import LogRocket from 'logrocket';

// Help with pages barel?
//import { AccountPage, HomePage, ListPage, SportsPage } from '@varsity/pages/index';

@Component({
    templateUrl: 'app.html'
})
export class AppComponent {
    isWebApp: boolean;
    platformDevice: string;
    platformType: string;
    intervalSub: Subscription;

    constructor(
        private localStorageService: LocalStorageService,
        private tokenService: TokenService,
        private loggingService: LoggingService,
        private notificationsService: NotificationsService,
        private platformService: PlatformService,
        private statusBar: StatusBar,
        private popoverCtrl: PopoverController,
        private accountService: AccountService,
        private settingsService: SettingsService,
        private app: App,
    ) {
        this.initializeApp();

    }

    initializeApp() {
        // copy the values for temp- from local to session
        if (this.localStorageService.get('temp-token')) {
            this.localStorageService.add('token', this.localStorageService.get('temp-token'));
            this.localStorageService.add('user', this.localStorageService.get('temp-user'));
            this.localStorageService.add('confirmation', this.localStorageService.get('temp-confirmation'));
            this.localStorageService.add('tokenExpireDate', this.localStorageService.get('temp-tokenExpireDate'));

            this.localStorageService.remove('temp-token');
            this.localStorageService.remove('temp-user');
            this.localStorageService.remove('temp-confirmation');
            this.localStorageService.remove('temp-tokenExpireDate');
        }

        // on a refresh, make sure these are not set
        this.localStorageService.remove("extendTimerPopoverDisplayed");
        this.localStorageService.remove("finalExtendTimerDisplayed");

        this.platformService.setPlatformType();
        this.platformService.setupFcm();
        this.platformService.handleDeepLinks();

        if (this.localStorageService.get('user')) {
            let user = JSON.parse(this.localStorageService.get('user')) as User;
            user.AutoLoggedIn = true;
            // if we have user, it is most likely a purchase redirect
            this.notificationsService.notifyUserLoginChanged(user);
        }


        if (this.localStorageService.get('confirmation')) {
            this.notificationsService.notifyConfirmationChanged(JSON.parse(this.localStorageService.get('confirmation')) as Confirmation);
        }

        // make sure we have a token
        this.tokenService
            .ensureValidToken()
            .then((token) => {

                // API logic not returning values, disable it for now
                // TODO enable this
                //let notificationsInterval = Observable.interval(10000);

                //this.intervalSub = notificationsInterval.subscribe((v) => {
                //    if (this.localStorageService.get('user')) {
                //        // only for logged in users
                //        this.accountService.getUserNotificationsCount()
                //            .take(1)
                //            .subscribe((value) => {
                //                this.notificationsService.notifyAvailableNotificationsChanged(value);
                //        });
                //    }
                //});
                document.title = (window as any).__GlobalSettings.ProductDisplay;
                if (JSON.parse(this.localStorageService.get("enableLogRocket"))) {
                    LogRocket.init(this.localStorageService.get("loggingProjId"));
                }
                this.settingsService.getSystemRoles((window as any).__GlobalSettings.Product, token.Token)
                    .subscribe((data) => {
                        let roles = {};
                        data.forEach((role) => {
                            roles[role.Name] = role.EnabledFlag;
                        });
                        this.notificationsService.notifySystemRolesAvailable(roles);
                    })
            });


        // Set watch for token
        this.tokenService.initializeTokenTimer();
        this.tokenService.timeUntilTokenExpires$
            .subscribe((value) => {
                if (value < this.tokenService.tokenExpireDelta) {
                    // TODO: token about to expire, show toastr to extend it ?
                }
            });

        this.notificationsService.sitelayout$
            .subscribe((layout) => {
                this.platformService.isCordova().then((v) => {
                    if (v) {
                        this.statusBar.backgroundColorByHexString(layout.MainBar1Color);
                        this.statusBar.styleLightContent();
                        this.statusBar.overlaysWebView(false);
                    }
                }, (error) => {

                });
            });

        this.platformService.webAppFlag$
            .subscribe(
                (value) => {
                    this.isWebApp = value;
                    this.loggingService.debug("isWebApp Observable -- ", value);
                },
                (error) => {
                    this.loggingService.error("Subscribe error: ", error)
            });

        this.platformService.platformDevice$
            .subscribe((value) => {
                this.platformDevice = value;
                this.loggingService.debug("Platform Device Observable --- ", value);
            }, (error) => {
                this.loggingService.error("Subscribe error: ", error)
            });

        this.platformService.platformType$
            .subscribe((value) => {
                this.platformType = value;
                this.loggingService.debug("Platform Type Observable ----", value);

            }, (error) => {
                this.loggingService.error("Subscribe error: ", error)
            });


        this.platformService.registerBackButton()
            .subscribe((value) => {
                //// Catches the active view
                let nav = this.app.getActiveNavs()[0];
                let activeView = nav.getActive();
                //// Checks if can go back before show up the alert
                if (nav.canGoBack()) {
                    nav.pop();
                } else {
                    if (activeView.name === 'HomePage') {
                        // show a login popup
                        let p = this.popoverCtrl.create(DisplayMessageComponent, {
                            params: {
                                icon: "warning",
                                header: "Exit application",
                                content: ["Are you sure you want to close the application ?"],
                                buttons: [{ tag: 'yes', text: 'Yes' }, { tag: 'no', text: 'No' }],
                                footer: null
                            }
                        }, {
                                enableBackdropDismiss: false,
                                cssClass: 'display-message'
                            });

                        p.present();

                        p.onWillDismiss((data) => {
                            if (data.button) {
                                if (data.button.tag == 'yes') {
                                    this.platformService.exitApp();
                                } else {
                                    nav.setRoot('HomePage');
                                }
                            }
                        });
                    } else {
                        nav.setRoot('home');
                    }

                    // private alertCtrl: AlertController
                    //if (activeView.name === 'HomePage') {
                    //    const alert = this.alertCtrl.create({
                    //        title: 'Close application',
                    //        message: 'This will close the application. Are you sure you want to proceed ?',
                    //        buttons: [{
                    //            text: 'Cancel',
                    //            role: 'cancel',
                    //            handler: () => {

                    //            }
                    //        }, {
                    //            text: 'Yes',
                    //            handler: () => {

                    //            }
                    //        }]
                    //    });
                    //    alert.present();
                    //} else {
                    //    nav.setRoot('home');
                    //}
                }
            });

        const isIE11 = /msie\s|trident\//i.test(window.navigator.userAgent);
        if (isIE11) {
            let p = this.popoverCtrl.create(DisplayMessageComponent, {
                params: {
                    icon: "bulb",
                    header: "You are using Internet Explorer 11 or lower",
                    content: ["For a better experience switch to Edge or Chrome or update your browser."],
                    buttons: [{ tag: 'yes', text: 'Close' }],
                    footer: null
                }
            }, {
                    enableBackdropDismiss: false,
                    cssClass: 'display-message'
                });

            p.present();

            p.onWillDismiss((data) => {
                if (data.button) {
                    if (data.button.tag == 'yes') {

                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts